import { PartnerCustomerInventoryTag } from "../../../models/inventory/PartnerCustomerInventoryTag";
import { APIResponse } from "../../../models/NetworkResponse";

import { getAPI, postAPI } from "../../../api/Networking";
export default class PartnerCustomerInventoryTagsAPI {
  getTagsByCustomerId = async (
    customerId: number,
  ): Promise<PartnerCustomerInventoryTag[]> => {
    try {
      const response = await getAPI(
        `/v1/partner-customer-inventory-tags/customer/${customerId}`,
      );
      return response.result as PartnerCustomerInventoryTag[];
    } catch (error) {
      throw error;
    }
  };
}
